---
title: Species Guides
description: A starter hub for species learning, FishIQ signals, habitat context, and responsible fishing notes.
---

# Species Guides

Species learning works best when it stays humble. Habitat, season, weather, pressure, and local conditions all matter.

FishIQ is designed to surface signals and guidance from patterns, not promises.

## Start here

- [FishIQ guide](/learn/fishiq)
- [Fishing map guide](/learn/fishing-map)
- [Catch log guide](/learn/catch-log)
